import React, { useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import { login } from '../services/api'; 
import '../assets/login.css';

const Login = ({ onLoginSuccess }) => {
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {        
      const response = await login( name, password ); 
      const { token } = response;

      const decoded = jwtDecode(token);
      const role = decoded.role || decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
      const username = decoded.unique_name || decoded.name;
      const id = decoded.id;
      
      localStorage.setItem('token', token);
      localStorage.setItem('role', role);
      localStorage.setItem('username', username);
      localStorage.setItem('id', id);

      onLoginSuccess({ token, role, username });
    } catch (err) {
      setError('Ошибка входа: ' + err.message);
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
        <h2>Авторизируйтесь</h2>
        <div className="input-container">
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Имя"
            className="input-field"
          />
          <input
            value={password}
            type="password"
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Пароль"
            className="input-field"
          />
        </div>
        <button type="submit" className="submit-btn">Войти</button>
        {error && <p style={{ color: 'red' }}>{error}</p>}
      </form>
    </div>
  );
};

export default Login;
